import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    userId: null,
    token: null,
};
const rootDataSlice = createSlice({
    name: 'rootData',
    initialState,
    reducers: {
        setUserId(state, action) {
            state.userId = action.payload;
        },
        setToken(state, action) {
            state.token = action.payload;
        }
    }
});
export const { setUserId, setToken } = rootDataSlice.actions;
export const rootDataReducer = rootDataSlice.reducer;
